
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/wireless",
      function () {
        return require("private-next-pages/expertise/wireless.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/wireless"])
      });
    }
  